import React from 'react';
import { Card, CardContent, Box, Typography, Chip } from '@mui/material';

const StatCard = ({ title, value, icon, color, bgGradient }) => {
  return (
    <Card
      sx={{
        height: '100%',
        background: bgGradient,
        border: `1px solid ${color}33`,
        transition: 'all 0.3s ease',
        borderRadius: 3,
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: 12,
        },
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <div
            style={{
              width: '64px',
              height: '64px',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: `linear-gradient(135deg, ${color} 0%, ${color}dd 100%)`,
              color: '#fff',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            }}
            dangerouslySetInnerHTML={{ __html: icon }}
          />
          <Chip
            label="Aggregate"
            size="small"
            sx={{
              bgcolor: `${color}20`,
              color: color,
              fontWeight: 600,
              height: 32,
              fontSize: '0.875rem',
            }}
          />
        </Box>
        
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            color: color,
            mb: 1.5,
            fontSize: { xs: '2rem', sm: '2.5rem' },
            lineHeight: 1.2,
          }}
        >
          {value}
        </Typography>
        
        <Typography 
          variant="body1" 
          sx={{ 
            color: 'text.secondary', 
            fontWeight: 500,
            fontSize: '1rem',
          }}
        >
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
};


export default StatCard;